__turbopack_context__.v({
  "fade-in": "WebsiteSearch-module-scss-module__NmOtVG__fade-in",
  "no-transform": "WebsiteSearch-module-scss-module__NmOtVG__no-transform",
  "rotate": "WebsiteSearch-module-scss-module__NmOtVG__rotate",
  "searchBarButton": "WebsiteSearch-module-scss-module__NmOtVG__searchBarButton",
});
